<template>
    <div class="success-box">
        <div class="success-text"  v-if="isfrom ==='ticket'"><img src="./static/success_icon.png" alt="">报名成功！</div>
        <div class="success-text" v-else><img src="./static/success_icon.png" alt="">预订成功！</div>
        <div class="btn" @click="jump('/home?meetingId='+meetingId)">返回首页</div>
        <div class="btn" @click="jump('/profile')">前往个人中心</div>
        <div class="btn" v-if="isfrom ==='ticket'&&meeting.hotelStatus==1" @click="jump('/hotel_list')">预定住宿</div>
    </div>
</template>

<script>
    import http from '@/utils/http'
    import apis from '@/utils/apis'
    export default {
        name: "paySuccess",
        data() {
            return{
                isfrom: 'ticket',
                meeting:null
            }
        },
        methods: {
            jump(path) {
                if(path.includes('/profile')){
                    if(!localStorage.getItem('audienceId')){
                        this.$alert('请去往首页登录个人中心', '',{
                        showClose: false,
                        callback: (action) => {
                            if(action==='confirm') {
                               this.$router.push('/home?meetingId='+this.meetingId)
                            }
                            }
                        })
                        return
                    }
                    this.$router.push(path)
                }
                this.$router.push(path)
            },
            async getAudienceMobile() {
                console.log(this.isfrom)
              if(this.isfrom ==='ticket'){
                  const params = {
                    mobile: this.$store.state.registerMobile || localStorage.getItem('registerMobile')
                  }
                  const res = await http.get(`/renren-fast/app/audienceCenter/getOrderAudienceMobile/${this.meetingId}`, {params})
                  if(res.code === 0 && res.audience.id) {
                      const audienceIdAndMeetingId = {meetingId: this.meetingId,audienceId: res.audience.id}
                      localStorage.setItem('audienceId', res.audience.id)
                      localStorage.setItem('audienceIdAndMeetingId',JSON.stringify(audienceIdAndMeetingId))
                  }
              }
          },
        },
        created() {
            this.isfrom = this.$route.query.from
            this.meeting=JSON.parse(localStorage.getItem('meeting'))
            this.getAudienceMobile()
        },
        computed: {
            meetingId() {
                return this.$store.state.meetingId || localStorage.getItem('meetingId')
            }
        }
    }
</script>

<style lang="stylus" scoped>
.success-box
    height 100vh
    width  100%
    background-color: #fff;
    .success-text
        font-size 40px
        text-align center
        width 300px
        margin 0px auto
        padding 100px
        background #fff
        img
            width 58px
            height 49px
            margin-right 20px
            vertical-align middle
    .btn
        font-size 31px
        color: #2852a6
        border 1px solid #2852a6
        border-radius 10px
        height 60px
        line-height 60px
        width 420px
        margin 60px auto
        text-align center
@media screen and (min-width: 800px)
       .success-box
            height 100vh
            width  900px
            margin 30px auto
            background-color: #fff;
            border-radius 15px
            .success-text
                font-size 26px
                text-align center
                width 300px
                margin 0px auto
                padding 100px
                background #fff
                img
                    width 40px
                    height 29px
                    margin-right 10px
                    vertical-align middle
            .btn
                font-size 20px
                color: #2852a6
                border 1px solid #2852a6
                border-radius 10px
                height 40px
                line-height 40px
                width 260px
                margin 30px auto
                text-align center 
</style>
